<script lang="ts">
  import { Col, FormGroup, Label, Row } from "sveltestrap";
  import Card from "../../../Core/Card.svelte";
  import { Checked, CustomRadio, Disabled, Option } from "../../../../utils/Constant/Constant";
  import RadioStates from "./RadioStates.svelte";
  import InlineCheckbox from "./InlineCheckbox.svelte";
</script>
<Col md="6">
    <Card headerTitle={CustomRadio} cardHeaderprops="pb-0">
      <div slot="contentbody">
        <Row>
          <Col sm="12">
            <h5>{CustomRadio}</h5>
          </Col>
          <Col>
            <FormGroup class="m-t-15 custom-radio-ml">
              <div class="radio radio-primary">
                <input id="radio1" type="radio" name="radio1" value="option1">
                <Label for="radio1">{Option}<span class="digits"> 1</span></Label>
              </div>
              <div class="radio radio-primary">
                <input id="radio3" type="radio" name="radio1" value="option1" disabled>
                <Label for="radio3">{Disabled}</Label>
              </div>
              <div class="radio radio-primary">
                <input id="radio4" type="radio" name="radio1" value="option1" checked>
                <Label for="radio4">{Checked}</Label>
              </div>
            </FormGroup>
          </Col>
          <RadioStates />
          <InlineCheckbox />
        </Row>
      </div>
    </Card>
</Col>